/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-loop-func */
import React from 'react';
// import { createContext, useContext } from 'react';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from 'lodash';

// import { axios } from '../../../../../v5/utils/axios';
// import { ReadAPIParams, success, successAPI, errorAPI } from '../../../../../v5/utils/utils';
// import Yup from '../../../../../v5/utils/yup';
// import {  } from '../../../../../v5/utils/enums';



export const fields = {
  customerNote: {
    id: 'customerNote',
    label: 'Note',
    placeholder: '',
  },
};


interface InitState {
  show: boolean,
  id: number|null,
  tab: string,
}

function NewReducer() {
  const name = 'jobFormJobTypeHistorySlice';


  const initialState: InitState = {
    show: false,
    id: null,
    tab: 'tab1',
  };


  const reducers = {
    resetSlice: () => {
      return initialState;
    },
    setShow: (state: InitState, action: PayloadAction<{ show: boolean, id: number|null }>) => {
      state.show = action.payload.show;
      state.id = action.payload.id;
    },
    setTab: (state: InitState, action: PayloadAction<string>) => {
      state.tab = action.payload;
    },
  };


  const apis = {
    
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();